import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components"

const Card = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div
      className={["card", blok.padding ? blok.padding : className].join(" ")}
    >
      {blok.content &&
        blok.content.map((c) =>
          React.createElement(Components(c.component), {
            key: c._uid,
            blok: c,
          })
        )}
    </div>
  </SbEditable>
)

Card.defaultProps = {
  className: "",
}

Card.propTypes = {
  blok: PropTypes.shape({
    padding: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  className: PropTypes.string,
}

export default Card
